import { Recipe } from '../models/Recipe';
import { hexToRgbObj } from '../utils/color';

export const isColorLight = (color: string): boolean => {
  const rgb = hexToRgbObj(color);
  return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000 > 128;
};

export const transformData = (recipesData: Recipe[]) => {
  return recipesData.map((item) => ({
    ...item,
    isColorLight: item.color ? isColorLight(item.color) : true,
    displayColor: item.color ?? 'whitesmoke',
    textColor: item.color && isColorLight(item.color) ? 'black' : 'white',
    ingredientDisplay: item.ingredients.map((ingredient) =>
      ingredient.item.name.split('(')[0].split('-')[0]
    ),
  }));
};

